<template>
    <iframe class="iframe" :src="iframeSrc"></iframe>
</template>

<script>
import config from "@/config";
import { beforeUnloadMixin } from "@/mixin/beforeUnloadMixin";

export default {
    name: "detail",
    mixins: [beforeUnloadMixin],
    computed: {
        iframeSrc() {
            if(this.$route.params.copy){
                return config.directorTemplateUrl
                    + "copyTemplateId=" + this.$route.params.id
                    + "&mId=" + this.$route.params.ownerId
                    + (this.$store.state.config.vrDirector ? '&vrmode' : '');
            }else {
                return config.directorTemplateUrl
                    + "effectGroupTemplateId=" + this.$route.params.id
                    + "&mId=" + this.$route.params.ownerId
                    + (this.$store.state.config.vrDirector ? '&vrmode' : '');
            }
        }
    },
    mounted(){
    }
};
</script>

<style scoped>
.iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
}
</style>